<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>Select Event</glxy-page-title>
    <glxy-page-actions>
      <a [routerLink]="'/loop'">
        <button mat-stroked-button color="primary">Cancel</button>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper maxWidth="100%">
    <div class="list mat-elevation-z1" *ngIf="events$ | async as events">
      <div class="message" *ngIf="(loading$ | async) === false && events.length === 0">Error loading events</div>
      <mat-nav-list *ngIf="events.length > 0">
        <a *ngFor="let event of events" [routerLink]="'../create'" [queryParams]="{ eventId: event.id }">
          <mat-list-item>
            <h3 matListItemTitle>{{ event.name }}</h3>
            <p matListItemLine>
              <span>{{ event.description }}</span>
            </p>
          </mat-list-item>
        </a>
      </mat-nav-list>
    </div>
    <div class="load-more">
      <mat-spinner *ngIf="loading$ | async" [diameter]="24" />
      <button mat-stroked-button *ngIf="hasMore && (loading$ | async) === false" (click)="loadMoreEvents()">
        Load more
      </button>
    </div>
  </glxy-page-wrapper>
</glxy-page>
